export const scrollFunctions = {
    data() {
        return {
            scrollParams: {
                typeSearchDoc: '',
                valueSearchDoc: '',
                idName: '',
                itemName: '',
                linkName: '',
                differenceBetweenElements: 100,
                arrayItems: [],
            },
            elementScroll: {},
            itemScroll: {},
            blockScroll: '',
            blockScrollClassName: '',
            blockScrollPercentScrolled: 0,
        }
    },
    beforeMount() {
        window.addEventListener('scroll', this.scrollEvent);
    },
    beforeUnmount() {
        window.removeEventListener('scroll', this.scrollEvent);
    },
    methods: {
        calculateScrollPercentage() {
            const blockScroll = document.querySelector(this.blockScrollClassName);
            if (blockScroll) {
                this.blockScrollPercentScrolled = (blockScroll.scrollTop / (blockScroll.scrollHeight - blockScroll.clientHeight)) * 100;
            }
        },
        scrollEvent() {
            console.log('scroll')
            this.calculateScrollPercentage();
            if (this.scrollParams.valueSearchDoc === '') {
                return;
            }
            if (this.scrollParams.typeSearchDoc === 'id' && this.scrollParams.valueSearchDoc !== '') {
                this.arrayScroll = this.scrollById(this.scrollParams.valueSearchDoc);
            } else if (this.scrollParams.typeSearchDoc === 'class' && this.scrollParams.valueSearchDoc !== '') {
                this.arrayScroll = this.scrollByClass(this.scrollParams.valueSearchDoc);
            }
            let itemById = this.getItemById;
            if (itemById !== this.itemScroll) {
                this.itemScroll = itemById;
                EventBus.$emit('change_item_scroll', this.itemScroll);
            }
            if (typeof this.itemScroll === 'object' && Object.keys(this.itemScroll).length === 0 && this.scrollParams.arrayItems.length > 0) {
                this.itemScroll = this.scrollParams.arrayItems[0];
                EventBus.$emit('change_item_scroll', this.itemScroll);
            }
            //console.log('this.itemScroll', this.itemScroll);
        },
        scrollById(idElement) {
            const findElements = document.querySelectorAll('[id^="' + idElement + '"]');
            const positionsArray = [];
            if (findElements.length > 0) {
                findElements.forEach((element, index) => {
                    positionsArray.push({
                        id: element.id,
                        element: element,
                        positionY: element.getBoundingClientRect().top
                    });
                })
            }
            return positionsArray;
        },
        scrollByClass(classElement) {
            const findElements = document.querySelectorAll('[class^="' + classElement + '"]');
            const positionsArray = [];
            if (findElements.length > 0) {
                findElements.forEach((element, index) => {
                    positionsArray.push({
                        id: element.id,
                        element: element,
                        positionY: element.getBoundingClientRect().top
                    });
                })
            }
            return positionsArray;
        }
    },
    computed: {
        getItemById() {
            let filterItems = this.scrollParams.arrayItems.filter(item => item[this.scrollParams.idName] === this.scrollContentId);
            return filterItems.length > 0 ? filterItems[0] : {};
        },

        scrollContentId() {
            if (this.elementScroll === {}) {
                this.elementScroll = this.arrayScroll.length !== 0 ? this.arrayScroll[0] : {};
            }
            for (let i = 1; i < this.arrayScroll.length; i++) {
                if (i >= 1 && this.arrayScroll[0].positionY > 0) {
                    this.elementScroll = this.arrayScroll[0];
                    break
                }
                if (this.arrayScroll[i - 1].positionY < 0 && this.arrayScroll[i].positionY >= 0) {
                    let difference = this.arrayScroll[i].positionY + this.arrayScroll[i - 1].positionY;
                    //console.log('difference', difference)
                    if (this.scrollParams.differenceBetweenElements >= difference) {
                        //console.log('this.elementScroll', this.elementScroll, 'this.arrayScroll[i - 1].positionY', this.arrayScroll[i - 1].positionY, 'this.arrayScroll[i].positionY', this.arrayScroll[i].positionY);
                        this.elementScroll = this.arrayScroll[i];
                        break;
                    }
                }
            }
            const findArray = this.scrollParams.arrayItems.filter(item => item[this.scrollParams.linkName] === this.elementScroll[this.scrollParams.typeSearchDoc]);
            //console.log('this.elementScroll', this.elementScroll);
            return findArray.length > 0 ? findArray[0][this.scrollParams.idName] : null;
        },
    }
}
